//메인화면 메뉴리스트
import React, { useState, useEffect } from "react";
import IPut from 'iput';
//MUI
import { Checkbox, MenuItem, TextField } from '@mui/material';
import USelectBox from "../../components/mui/USelectBox";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

import { API } from "../../config";
import { fni18n } from "../../services/commonService";
import {
    getAPI
} from "../../services/commonService";

const BranchModify = (props) => {
    const modify = props.data;
    const onParamsChange = props.onParamsChange;
    const onCheckboxChange = props.onCheckboxChange;
    const [branchGroups, setBranchGroups] = useState([]);
    const [regions, setRegions] = useState([]);
    
    //화면 로드 시
    useEffect(() => {
        const getLoadData = async () => {
        try {
            await loadBranchGroup()
            await loadComboBoxBranchGroup()
        } catch (e) {
            console.log(e)
        }
        };
        getLoadData();
    }, []);

    const loadComboBoxBranchGroup = async () => {
        try {
            const res = await getAPI(API.COMMON.BRANCH_GROUP, {branchGroupTy: "BIZ_TY",useYn:"Y"});
            const _inputData = res.data.result.map((m) => ({
                cd: m.id,
                name: m.branchGroupNm,
            }));
            setBranchGroups(_inputData);
        } catch (e) {
            console.error(e.message);
        }
    };
    
    const loadBranchGroup = async () => {
        try {
            const res = await getAPI(API.COMMON.BRANCH_GROUP, {branchGroupTy: "RGN_TY",useYn:"Y"});
            const _inputData = res.data.result.map((m) => ({
                cd: m.id,
                name: m.branchGroupNm,
            }));
            setRegions(_inputData);
        } catch (e) {
            console.error(e.message);
        }
    };

    return(
        <div className="pop-container">
            {/* 상단메뉴명 */}
            <div className="header">
                {fni18n('지점 등록/수정')}
            </div>
            <div className="contents">
            <TableContainer className="table-container">
                <Table className="table" size="small">
                    <TableBody>
                    <TableRow>
                        <TableCell className="table-cell-title">{fni18n('지점')}</TableCell>
                        <TableCell className="table-cell">
                            {modify.chkCreate == true && 
                                <TextField
                                    fullWidth
                                    size="small"
                                    name="branchCd"
                                    value={modify.branchCd||""}
                                    required
                                    onChange={onParamsChange}
                                    variant="outlined"
                                    disabled
                                />
                            }
                            {modify.chkCreate == false && 
                                <TextField
                                    fullWidth
                                    size="small"
                                    name="branchCd"
                                    value={modify.branchCd||""}
                                    required
                                    onChange={onParamsChange}
                                    variant="outlined"
                                />
                            }
                        </TableCell>
                        <TableCell className="table-cell-title">{fni18n('지점명')}</TableCell>
                        <TableCell className="table-cell">
                            <TextField
                                fullWidth
                                size="small"
                                name="branchNm"
                                value={modify.branchNm||""}
                                required
                                onChange={onParamsChange}
                                variant="outlined" />
                        </TableCell>
                        <TableCell className="table-cell-title">{fni18n('사용여부')}</TableCell>
                        <TableCell className="table-cell">
                            <FormControlLabel
                                sx={{mb:0, mt:0 }}
                                control={
                                    <Checkbox
                                    name="useYn"
                                    checked={modify.useYn == "N" ? false : true}
                                    onChange={e => onCheckboxChange(e)}
                                    />
                                }
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="table-cell-title">{fni18n('고객사')}</TableCell>
                        <TableCell className="table-cell">
                            <FormControl size="small" fullWidth={true}>
                                <USelectBox name="bizTy" items={branchGroups} onItemChange={onParamsChange} defaultValue={modify.bizTy||"N/A"}/>
                            </FormControl>
                        </TableCell>
                        <TableCell className="table-cell-title">{fni18n('권역')}</TableCell>
                        <TableCell className="table-cell">
                            <FormControl size="small" fullWidth={true}>
                                <USelectBox name="rgnTy" items={regions} onItemChange={onParamsChange} defaultValue={modify.rgnTy||"N/A"}/>
                            </FormControl>
                        </TableCell>
                        <TableCell className="table-cell-title">{fni18n('주소')}</TableCell>
                        <TableCell className="table-cell">
                            <TextField
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="addr"
                                value={modify.addr||""}
                                onChange={onParamsChange}
                            />
                        </TableCell>
                    </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            </div>
        </div>
    );
}

export default BranchModify;
